import React from "react";

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";


const StepSmtpSummary = ({emailFrom}) => {

    return <Stack spacing={2}>
        <Typography variant="body2">
            Cliccando su salva verrà impostato <strong>SMTP</strong> come servizio di invio posta.
        </Typography>
        <Typography variant="body2">
            Le email verranno inviate con le seguenti impostazioni smtp: mittente <strong>{emailFrom}</strong>.
        </Typography>
    </Stack>
}

export default StepSmtpSummary;